<div class="grid-container padding-y-4">
  <div class="grid-row">
    <legend class="usa-legend usa-legend--large">FRT Shipment POD Report</legend>
  </div>
  <form id="frtShipmentPodFormGroup" role="form" [formGroup]="frtShipmentPodFormGroup" (ngSubmit)="getFrtShipmentPod()">
    <div class="grid-row grid-gap margin-top-2">
      <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
        <img src="assets/uswds/img/usa-icons/file_download.svg" alt="user_icon"> Right click on the report and select the appropriate options to export.
      </div>
    </div>
  </form>

  <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12 margin-top-2">
    @if (gridOptions) {
      <ag-grid-angular style="height: 600px;" class="ag-theme-alpine" [gridOptions]="gridOptions"
        [rowData]="rowData"
        [columnDefs]="frtShipmentPodColumnDefs"
        [enableRangeSelection]="true">
      </ag-grid-angular>
    }
  </div>
</div>
